module.exports = __webpack_public_path__ + "static/media/ithra.e045b0c2.svg";